import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=6a26b3ca&"
import script from "./teams.vue?vue&type=script&lang=ts&"
export * from "./teams.vue?vue&type=script&lang=ts&"
import style0 from "./teams.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports